<div class="form-container">
    <h2>Create Company</h2>
  
    <form [formGroup]="companiesForm" (ngSubmit)="createCompany()">
      <div class="form-group">
        <label>Company Name:</label>
        <input type="text" class="form-control" formControlName="name" placeholder="Company Name">
        <div *ngIf="errors.name" class="text-danger">
          <ul>
            <li *ngFor="let error of errors.name">{{ error }}</li>
          </ul>
        </div>
      </div>
      
      <div class="form-group">
        <label>VAT Number:</label>
        <input type="text" class="form-control" formControlName="vatNumber" placeholder="VAT Number">
        <div *ngIf="errors.vatNumber" class="text-danger">
          <ul>
            <li *ngFor="let error of errors.vatNumber">{{ error }}</li>
          </ul>
        </div>
      </div>

      <div class="form-group">
        <label>Company Type:</label>
        <select class="form-control" formControlName="type">
          <option value="">Select Type</option>
          <option value="Supplier">Supplier</option>
          <option value="Vessel Owner">Vessel Owner</option>
        </select>
        <div *ngIf="errors.type" class="text-danger">
          <ul>
            <li *ngFor="let error of errors.type">{{ error }}</li>
          </ul>
        </div>
      </div>

      <div *ngIf="errors.general" class="text-danger">
        <ul>
          <li *ngFor="let error of errors.general">{{ error }}</li>
        </ul>
      </div>
    
      <button type="submit" class="btn btn-primary">
        {{ isSubmitting ? 'Creating...' : 'Create' }}
      </button>
    </form>
  </div>
  